import { Label } from '@coolblue-development/becky';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { AgentAllocationLabel } from '../../../../constants/agentAllocationLabels';
import { getAgentAllocationLabelColor } from '../../../../utils/agentAllocationLabel';

export const agentsDashboardColumns: GridColDef[] = [
  { field: 'username', headerName: 'Username', width: 200, minWidth: 150 },
  { field: 'activity', headerName: 'Activity', width: 200, minWidth: 150 },
  { field: 'duration', headerName: 'Duration', width: 150, minWidth: 150 },
  { field: 'routingProfile', headerName: 'Routing Profile', width: 250, minWidth: 150 },
  { field: 'defaultRoutingProfile', headerName: 'Default Routing Profile', width: 250, minWidth: 150 },
  { field: 'availability', headerName: 'Availability', width: 150, minWidth: 150 },
  {
    field: 'label',
    headerName: 'Label',
    width: 150,
    minWidth: 150,
    renderCell: (params: GridRenderCellParams) => {
      const value = params.value as AgentAllocationLabel;

      return <Label color={getAgentAllocationLabelColor(value)}>{value}</Label>;
    }
  },
  { field: 'country', headerName: 'Country/Language', width: 200, minWidth: 150 }
];
